const Question = [
    {
        id:1,
        question: 'Is my account set up yet?',
        answer: 'To verify if your user account is set-up, you may try to logon using the username and password provided to you via email from Checkpoint Systems.'
    },
    {
        id:1,
        question: 'What should I do if I forget my password?',
        answer: 'Enter your username in the Username entry box provided on the login screen.  Select the Forgot your password? link.  A dialog box will be displayed asking if you “Are sure you would like to reset your password”.  Select yes.'
    },
    {
        id:1,
        question: 'What should I do if I forget my Username?',
        answer: 'Please send an email or phone your Checkpoint Customer Service Representative and state that you have lost or forgotten your username and password.'
    },
    {
        id:1,
        question: 'How do I know the site has a secure connection?',
        answer: 'CheckNet is a VeriSign secure site.  To verify CheckNet is the site you intended to access in a secure fashion prior to sending any secure information select the VeriSign Logo.'
    }
]

export default Question;